import { render, staticRenderFns } from "./SfHero.vue?vue&type=template&id=69664709"
import script from "./SfHero.vue?vue&type=script&lang=js"
export * from "./SfHero.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfHero.vue?vue&type=style&index=0&id=69664709&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "0cc38346"
  
)

export default component.exports